import React from "react";
import FormLabel from "@material-ui/core/FormLabel";
import IconButton from "@material-ui/core/IconButton";
import AddCircle from "@material-ui/icons/AddCircle";
import InputBase from "@material-ui/core/InputBase";
import RemoveCircle from "@material-ui/icons/RemoveCircle";
import FormControl from "@material-ui/core/FormControl";
import { makeStyles } from "@material-ui/core/styles";

/**
 * styles.
 * @type {(props?: any) => ClassNameMap<"btnIcon"|"btnIconWrapper"|"floorInput"|"floor">}
 */
const useStyles = makeStyles((theme) => ({
  floor: {
    // margin: "0 1rem",
    display: "inherit",
  },
  btnIcon: {
    fontSize: "1rem",
    [theme.breakpoints.up("xs")]: {
      fontSize: "1.7rem",
    },
  },
  btnIconWrapper: {
    padding: ".7rem",
  },
  floorInput: {
    width: "1.5rem",
    height: "1.5rem",
    fontSize: ".9rem",
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: 3,
    verticalAlign: "middle",
    ["& input"]: {
      textAlign: "center",
      boxShadow: "unset",
      height: "inherit",
      margin: "auto",
      padding: "unset",
    },
  },
}));
/**
 * Quantity form which contains add and remove and the input to show the current value.
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const QuantityButton = (props) => {
  const classes = useStyles();
  return (
    <FormControl className={classes.floor}>
      <FormLabel color={"primary"}>{props.title ?? ""}</FormLabel>
      <IconButton
        onClick={props.add}
        color={"secondary"}
        style={{ paddingRight: 0 }}
      >
        <AddCircle className={classes.btnIcon} />
      </IconButton>
      <InputBase
        readOnly={true}
        className={classes.floorInput}
        value={props.value}
      />
      <IconButton
        disabled={!props.value}
        onClick={props.remove}
        color={"secondary"}
        style={{ paddingLeft: 0 }}
      >
        <RemoveCircle className={classes.btnIcon} />
      </IconButton>
    </FormControl>
  );
};
export default QuantityButton;
